module.exports = "<div id=\"organization\" class=\"clearfix\" ng-controller=\"organizationCtrl as vm\">\n  <div class=\"organization-inner clearfix section-full-height\">\n    <sidebar></sidebar>\n    <div id=\"content\" class=\"clearfix\">\n      <div class=\"content-inner\" ui-view>\n      </div>\n    </div>\n  </div>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/components/organization/organization.html
// module id = 1168
// module chunks = 0